<nav class="navbar navbar-light navbar-expand-lg ">
    <!-- Navbar content -->
    <a class="navbar-brand" [routerLink]="['/']">
        <img src="assets/img/logo.png" style="height: 50px;" />
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
        <ul class="navbar-nav">
            <li class="nav-item active">
                <a class="nav-link" [routerLink]="['/']">Inicio <span class="sr-only">(current)</span></a>
            </li>
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    Ortodoncistas
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item" [routerLink]="[ '/login' ]">Acceso</a>
                </div>
            </li>
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    Pacientes
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item"  href="/pacientes#encontrar-doctor">Doctores certificados</a>
                </div>
            </li>
            <li class="nav-item">
                <a class="nav-link" (click)="scroll(about)"  href="javascript:void(0)" >Acerca de</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" (click)="scroll(contact)"  href="javascript:void(0)" >Contacto</a>
            </li>
        </ul>
    </div>
</nav>